import SpriteSymbol from "../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "scalability",
  "use": "scalability-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"scalability\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M16 27v-1h2v1h6v-3h3V8h-3V5H8v3H5v6h1v2H5v8h3v3zm8-27h8v8h-3v16h3v8h-8v-3H8v3H0v-8h3V8H0V0h8v3h16zm2 5v1h4V2h-4v3zM2 2v4h4V2zm24 27v1h4v-4h-4v3zM2 26v4h4v-4H2zm6-12h2v2H8zm4 0h2v2h-2zm4 0h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2z\" data-name=\"path-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol